import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4da38435"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "FTLOrderCargo"
}
const _hoisted_2 = { class: "FTLOrderCargo__container" }
const _hoisted_3 = { class: "container__block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "Информация о грузе", -1))
const _hoisted_5 = { class: "block__content" }
const _hoisted_6 = { class: "block__field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Описание", -1))
const _hoisted_8 = { class: "field__value" }
const _hoisted_9 = { class: "block__field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Грузоподъёмность машины", -1))
const _hoisted_11 = { class: "field__value" }
const _hoisted_12 = { class: "block__field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Высота (м)", -1))
const _hoisted_14 = { class: "field__value" }
const _hoisted_15 = { class: "block__field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Ширина (м)", -1))
const _hoisted_17 = { class: "field__value" }
const _hoisted_18 = { class: "block__field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Количество мест", -1))
const _hoisted_20 = { class: "field__value" }
const _hoisted_21 = { class: "block__field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Тип транспорта", -1))
const _hoisted_23 = { class: "field__value" }
const _hoisted_24 = { class: "block__field" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Тип погрузки", -1))
const _hoisted_26 = { class: "field__value" }
const _hoisted_27 = { class: "block__field" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Страховка", -1))
const _hoisted_29 = { class: "field__value" }
const _hoisted_30 = { class: "block__field" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Негабарит", -1))
const _hoisted_32 = { class: "field__value" }
const _hoisted_33 = { class: "block__field" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Номер заказа заказчика", -1))
const _hoisted_35 = { class: "field__value" }
const _hoisted_36 = { class: "block__field" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Кубатура машины", -1))
const _hoisted_38 = { class: "field__value" }
const _hoisted_39 = { class: "block__field" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Длина", -1))
const _hoisted_41 = { class: "field__value" }
const _hoisted_42 = { class: "block__field" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Вес", -1))
const _hoisted_44 = { class: "field__value" }
const _hoisted_45 = { class: "block__field" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Груз штабелируется", -1))
const _hoisted_47 = { class: "field__value" }
const _hoisted_48 = { class: "block__field" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Температурный режим", -1))
const _hoisted_50 = { class: "field__value" }
const _hoisted_51 = { class: "block__field" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Объявленная цена", -1))
const _hoisted_53 = { class: "field__value" }
const _hoisted_54 = { class: "block__field" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Особые условия", -1))
const _hoisted_56 = { class: "field__value" }
const _hoisted_57 = { class: "block__field" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Наименование товара", -1))
const _hoisted_59 = { class: "field__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.ftlOrder)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.ftlOrder.description || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.ftlOrder.car_info)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.ftlOrder.car_info.load_capacity || '-'), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" - ")
                      ], 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.ftlOrder.height || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.ftlOrder.width || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.ftlOrder.places || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.ftlOrder.transport_type_name || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  (_ctx.ftlOrder.car_info)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.ftlOrder.car_info.loading_type || '-'), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" - ")
                      ], 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.ftlOrder.insurance || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  (_ctx.ftlOrder.car_info)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.ftlOrder.car_info.oversized_cargo)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("Да")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("Нет")
                            ], 64))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Нет ")
                      ], 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.ftlOrder.dop_order_number || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, [
                  (_ctx.ftlOrder.car_info)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.ftlOrder.car_info.cubature || '-'), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" - ")
                      ], 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.ftlOrder.length || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.ftlOrder.weight || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  (_ctx.ftlOrder.is_stacked)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" Да ")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Нет ")
                      ], 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createElementVNode("div", _hoisted_50, [
                  (_ctx.ftlOrder.car_info)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.ftlOrder.car_info.temperature_mode || '-'), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" - ")
                      ], 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.ftlOrder.declared_price || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.ftlOrder.special_conditions || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.ftlOrder.cargo_name || '-'), 1)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}